/* ============================================================
   PRILU — Back to Glow School
   Rail controls, reveal-on-scroll (desktop only), quick-add.
   Idempotent: safe to load once per section tag.
   ============================================================ */
(function () {
  'use strict';

  if (window.__priluSchoolInit) return;
  window.__priluSchoolInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll (>=750px only) ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-ps-reveal]:not(.is-revealed)');
    if (!targets.length) return;

    if (reduceMotion || window.innerWidth < 750 || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- rails ---------- */
  function initRails() {
    document.querySelectorAll('[data-ps-rail-root]:not([data-ps-rail-ready])').forEach(function (root) {
      root.setAttribute('data-ps-rail-ready', '');

      var rail = root.querySelector('[data-ps-rail]');
      var prev = root.querySelector('[data-ps-rail-prev]');
      var next = root.querySelector('[data-ps-rail-next]');
      if (!rail) return;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function sync() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        var scrollable = rail.scrollWidth > rail.clientWidth + 4;
        prev.hidden = !scrollable;
        next.hidden = !scrollable;
      }

      function go(dir) {
        rail.scrollBy({
          left: dir * step(),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- quick add ----------
     Progressive enhancement over the plain product form: if fetch
     is available we POST to /cart/add.js and ask the theme to
     refresh its cart, otherwise the form submits normally.
  */
  function initQuickAdd() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-ps-quick-add]');
      if (!form || !window.fetch) return;

      event.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-to-cart failed');
          return res.json();
        })
        .then(function () {
          if (btn) btn.textContent = 'Added ✓';

          // Nudge whichever cart UI the theme is using.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          var drawer = document.querySelector('cart-drawer-component, cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();

          setTimeout(function () {
            if (btn) {
              btn.textContent = original;
              btn.disabled = false;
            }
          }, 1600);
        })
        .catch(function () {
          // Fall back to a real navigation so the customer is never stuck.
          form.removeAttribute('data-ps-quick-add');
          form.submit();
        });
    });
  }

  /* ---------- sticky compact header on scroll ---------- */
  function initStickyHeader() {
    var root = document.documentElement;
    var last = 0;
    var ticking = false;

    function update() {
      var y = window.scrollY || 0;
      root.classList.toggle('ps-scrolled', y > 80);
      last = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  function boot() {
    initReveal();
    initRails();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  initQuickAdd();

  // Theme editor re-renders sections without a full reload.
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initRails();
  });
})();
